import { render, staticRenderFns } from "./TTransition.vue?vue&type=template&id=12c9769a&scoped=true&"
import script from "./TTransition.vue?vue&type=script&lang=js&"
export * from "./TTransition.vue?vue&type=script&lang=js&"
import style0 from "./TTransition.vue?vue&type=style&index=0&id=12c9769a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9769a",
  null
  
)

/* custom blocks */
import block0 from "./TTransition.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports